import styled from 'styled-components';

const Header = styled.div<{ fontSize: number }>`
    font-size: ${(props) => props.fontSize}%;
    line-height: 1.5;
    font-weight: bold;
    text-align: left;
    padding-left: 10px;
`;

export default Header;
